import React, { Component } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Table,
  Label,
  CardFooter,
  CardHeader,
  Form,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import PageSpinner from "../components/PageSpinner";
import * as Server from "../Server";
import Page from "../components/Page";
import Input from "reactstrap/lib/Input";
// import debounce from "../utils/debounce";

class SelectTeamPlayers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      // searchValue: "",
      players: props.players || {},
      playersAdded: props.playersAdded || {},
      selectdPlayers: [],
      year: "",
      globalSearch: "",
      teamName: props.teamName || "",
    };
    this.selectAll = this.selectAll.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = async (user) => {
    if (this.state.selectdPlayers.find((p) => p.child._id === user.child._id)) {
      this.setState({
        selectdPlayers: this.state.selectdPlayers.filter(
          (player) => player.child._id !== user.child._id
        ),
      });
    } else {
      this.state.selectdPlayers.push(user);
    }
    await this.forceUpdate();
  };

  selectAll = async () => {
    if (
      this.state.selectdPlayers.length > 0 &&
      this.state.selectdPlayers.length !== this.state.players.length
    ) {
      this.setState({ selectdPlayers: [] });
      await this.state.players.map((player) =>
        this.state.selectdPlayers.push(player)
      );
    }

    if (this.state.selectdPlayers.length > 0) {
      this.setState({ selectdPlayers: [] });
    }
    if (this.state.selectdPlayers.length === 0) {
      await this.state.players.map((player) =>
        this.state.selectdPlayers.push(player)
      );
    }
    this.forceUpdate();
  };

  handleChangeYear = async (date) => {
    if (date instanceof Date) {
      let year = date.getFullYear() || "";
      this.setState({ year });
    } else if (date === null) {
      this.setState({ year: date });
    }
  };

  closeSelectPlayerPage() {
    this.props.closeSelectplayersPage();
  }

  submitPlayers = async (e) => {
    e.preventDefault();
    await this.props.getPlayers(this.state.selectdPlayers);
    this.closeSelectPlayerPage();
  };

  filterList = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/filter/players",
        method: "POST",
        data: {
          playersAdded: this.state.playersAdded,
          globalSearch: this.state.globalSearch,
          year: this.state.year,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          players: response.players,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  // filterByStaff = debounce(async (event) => {
  //   try {
  //     event.preventDefault();
  //     if (!this.state.staffName) {
  //       return this.setState({ players: this.props.players });
  //     }
  //     this.setState({ showLoader: true, searchValue: "", year: "" });
  //     let response = await Server.request({
  //       url: "rushsoccer/coach/playerlist",
  //       method: "POST",
  //       data: { coachName: this.state.staffName.trim() },
  //     });
  //     if (response) {
  //       this.setState({
  //         showLoader: false,
  //         players: response.players,
  //       });
  //     }
  //   } catch (error) {
  //     this.setState({ showLoader: false });
  //     this.notificationSystem.addNotification({
  //       message: error.message,
  //       level: "error",
  //     });
  //   }
  // }, 500);

  render() {
    return (
      <div>
        <Page
          title={"Select-Players"}
          breadcrumbs={[{ name: "Select-Players", active: true }]}
        >
          <PageSpinner showLoader={this.state.showLoader} />
          <Form onSubmit={this.submitPlayers}>
            <Card>
              <CardHeader className="mb-0" style={{ textTransform: "unset" }}>
                <Row className="mt-3 mb-3">
                  <Col lg={6} md={6} xl={6} sm={12} xs={12}>
                    <Label>Team Name:</Label>
                    <Input disabled icon="search" value={this.state.teamName} />
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col lg={6} md={6} xl={6} sm={12} xs={12}>
                    <Label>Search:</Label>
                    <Input
                      icon="search"
                      value={this.state.globalSearch}
                      placeholder="Search"
                      onChange={(event) =>
                        this.setState({
                          globalSearch: event.target.value,
                        })
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col lg={6} md={6} xl={6} sm={12} xs={12}>
                    <div>
                      <Label>Search By Date Of Birth:</Label>
                    </div>
                    <DatePicker
                      selected={
                        this.state.year &&
                        new Date().setFullYear(Number(this.state.year))
                      }
                      onChange={(date) => this.handleChangeYear(date)}
                      showYearPicker
                      dateFormat="yyyy"
                      style={{ width: "50% !important" }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col lg={6} md={6} xl={6} sm={12} xs={12}>
                    <Button
                      className="mr-3"
                      color="primary"
                      onClick={(event) => this.filterList(event)}
                    >
                      Filter
                    </Button>
                    <Button
                      onClick={() =>
                        this.setState({
                          globalSearch: "",
                          year: "",
                        })
                      }
                    >
                      Reset Filter
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="float-right mr-5 d-flex pl-4">
                  <Button onClick={this.selectAll} className="mb-3 mr-2">
                    Select All
                  </Button>
                  <Button className="mb-3 mr-2" type="submit">
                    Submit
                  </Button>
                  <Button
                    className="mb-3"
                    onClick={(e) => this.closeSelectPlayerPage()}
                  >
                    Cancel
                  </Button>
                </div>
                <Table>
                  <thead>
                    <tr>
                      <th>Photo</th>
                      <th>Name</th>
                      <th>DateOfBirth</th>
                      <th>Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.players && this.state.players.length > 0 ? (
                      this.state.players.map((rushuser, index) => (
                        <tr key={rushuser.child._id}>
                          <td className=" w-25 h-25">
                            {rushuser.child.data.files &&
                            rushuser.child.data.files.length > 0
                              ? rushuser.child.data.files.map(
                                  (file, index) =>
                                    file.name === "photo" && (
                                      <img
                                        key={index}
                                        src={file.url}
                                        className="img-responsive"
                                        alt=""
                                        style={{ width: "100px" }}
                                      />
                                    )
                                )
                              : "Not Available"}
                          </td>
                          <td>
                            {rushuser.child.data.firstName +
                              " " +
                              rushuser.child.data.lastName}
                          </td>
                          <td>
                            {rushuser.child.data.birthday &&
                              new Date(
                                rushuser.child.data.birthday
                              ).toDateString()}
                          </td>
                          <td>
                            <Label
                              className="ml-4 pb-3 text-center"
                              onChange={() => this.handleChange(rushuser)}
                            >
                              <Input
                                type="checkbox"
                                style={{ width: "20px", height: "30px" }}
                                checked={this.state.selectdPlayers.find(
                                  (player) =>
                                    rushuser.child._id === player.child._id
                                )}
                              ></Input>
                            </Label>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr style={{ background: "rgba(0, 0, 0, 0.075)" }}>
                        <td colSpan="4" className="text-center">
                          No players Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <div className="d-flex justify-content-center ">
                  <Button className="mr-5" type="submit">
                    Submit
                  </Button>
                  <Button onClick={(e) => this.closeSelectPlayerPage()}>
                    Cancel
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Form>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default SelectTeamPlayers;
